import { useEffect } from 'react';

import { useBlocker } from 'react-router-dom';

const UNSAVED = 'You have unsaved changes. Are you sure you want to leave?';

export const useNavigationBlocker = (isDirty: boolean, message = UNSAVED) => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return (
      isDirty &&
      currentLocation.pathname !== nextLocation.pathname &&
      !confirm(message)
    );
  });

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isDirty) {
        if (!confirm(message)) {
          event.preventDefault();
        }
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty, message]);

  return blocker;
};
